
// NCE Inhaltsverzeichnis
$('.ttgNCEInhalt').each(function() {
    var uid = $(this).data("uid");

    $(".ttgNCEContainer " + $(this).data("tag")).each(function(i) {
        if (!$(this).hasClass("inhalt-headline")) {
            $(this).attr("id", "inhalt" + i);
            $("#ttgNCECollapse" + uid + " ol").append("<li><a href='#inhalt" + i + "' class='ttgStandardLink'>" + $(this).text() + "</a></li>");
        }
    });
});